import { render, staticRenderFns } from "./Readmore.vue?vue&type=template&id=80d48abe"
import script from "./Readmore.vue?vue&type=script&lang=ts"
export * from "./Readmore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports